module.exports = __webpack_public_path__ + "static/img/book.4c7bda1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/book.jpg
// module id = 02fN
// module chunks = 1